import '../../styles/styles.scss'
import React from 'react'
import { Helmet } from 'react-helmet'
import { Redirect } from '@reach/router'
import { useAuth } from '../auth/AuthContext'

export default ({ pageTitle, children }) => {
  const { isAuthenticated } = useAuth()

  if (isAuthenticated) return <Redirect to="/admin" noThrow />

  return (
    <React.Fragment>
      <Helmet>
        <title>{pageTitle}</title>
      </Helmet>

      {children}
    </React.Fragment>
  )
}
